import { Contact } from "../../orderEntry/types/Contact";
import { InternalUser } from "../../types/app";

export const isSalesRepsIdentical = (salesRepsArrays: Contact[][]) => {
  if (salesRepsArrays.length < 2) return true;

  const normalized = salesRepsArrays.map((arr) => {
    const idsBySlot = [0, 1, 2].map((index) => String(arr[index]?.id || "").toLowerCase());
    return idsBySlot.join(",");
  });

  return new Set(normalized).size === 1;
};

export const getUniqueListOfSalesReps = (salesRepsArrays: Contact[][]) => {
  return [...new Map(salesRepsArrays.flatMap((inner) => inner).map((item) => [item.id, item])).values()];
};

export const convertContactToInternalUserSalesRep = (contact: Contact): InternalUser => {
  const { lookupCode = "", id = "", name = "" } = contact;
  return {
    lookupCode: lookupCode || "",
    fullName: name || "",
    selectId: id || "",
    salesRepId: id || ""
  } as InternalUser;
};

export const defaultThreeRepsEntries = (salesReps: (InternalUser | null)[]) => {
  const [a = null, b = null, c = null] = salesReps || [];
  return [a, b, c] as (InternalUser | null)[];
};
